import { Box, Typography, Divider } from "@mui/material";
import QRCode from "react-qr-code";
import { getPronoun } from "../utils/certificateUtils";

const ExperienceCertificate = ({ data }) => {

    const toCamelCase = (str) => {
        return str
            ?.toLowerCase()
            .replace(/[^a-zA-Z0-9 ]/g, '')
            .split(' ')
            .map((word, index) =>
                index === 0
                    ? word.charAt(0).toUpperCase() + word.slice(1)
                    : word.charAt(0).toUpperCase() + word.slice(1)
            )
            .join(' ');
    };

    return (
        <Box
            id="certificate"
            sx={{
                maxWidth: 900,
                mx: "auto",
                p: 6,
                bgcolor: "#fff",
                border: "1px solid #e0e0e0",
                boxShadow: "0 8px 30px rgba(0,0,0,0.06)",
                position: "relative",
                fontFamily: "'Times New Roman', serif"
            }}
        >
            {/* OUTER BORDER */}
            <Box
                sx={{
                    border: "4px solid #2f2f2f",
                    p: 1,
                    height: "100%"
                }}
            >
                {/* INNER BORDER */}
                <Box
                    sx={{
                        border: "1.5px solid #2f2f2f",
                        p: 6,
                        height: "100%",
                        position: "relative"
                    }}
                >


                    {/* WATERMARK */}
                    <Typography
                        sx={{
                            position: "absolute",
                            top: "45%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            fontSize: 120,
                            color: "rgba(0,0,0,0.03)",
                            fontWeight: "bold",
                            pointerEvents: "none",
                            userSelect: "none"
                        }}
                    >
                        CERTIFIED
                    </Typography>

                    {/* HEADER */}
                    <Box textAlign="center" mb={4}>
                        <Typography variant="h4" fontWeight="bold" letterSpacing={1}>
                            {toCamelCase(data.companyName)}
                        </Typography>
                        <Typography fontSize={14}>
                            Recognised by Govt. of India | Affiliation No: {data.diseCode}
                        </Typography>
                        <Typography fontSize={13}>
                           {toCamelCase(data.companyAddress)}
                        </Typography>
                    </Box>

                    <Divider />

                    {/* TITLE */}
                    <Box textAlign="center" my={3}>
                        <Typography
                            variant="h5"
                            fontWeight="bold"
                            // borderBottom={'1px solid'}
                            sx={{ letterSpacing: 2 }}
                        >
                            {data.type === "service"
                                ? "SERVICE CERTIFICATE"
                                : "EXPERIENCE CERTIFICATE"}
                        </Typography>
                    </Box>

                    {/* BODY */}
                    <Typography sx={{ textAlign: "justify", lineHeight: 1.8 }}>
                        This is to certify that <b>{toCamelCase(data.name)}</b> was employed with
                        <b> {toCamelCase(data.companyName)}</b> as a <b>{data.designation}</b> in the
                        <b> {toCamelCase(data.department)}</b> department from
                        <b> {data.fromDate}</b> to <b>{data.toDate}</b>.
                    </Typography>

                    <Typography sx={{ mt: 2, textAlign: "justify", lineHeight: 1.8 }}>
                        During the tenure of employment, {data.gender === "Male" ? "he" : "she"} demonstrated
                        professionalism, dedication, and sincerity in carrying out assigned
                        responsibilities. {data.gender === "Male" ? "He" : "She"} maintained
                        good conduct and ethical standards throughout the period of service.
                    </Typography>

                    <Typography sx={{ mt: 2 }}>
                        We wish {data.gender === "Male" ? "him" : "her"} all the best in future
                        endeavors.
                    </Typography>

                    {/* FOOTER */}
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="flex-end"
                        mt={8}
                    >
                        <Box>
                            <Typography fontSize={14}>
                                Certificate No: <b>{data.certificateNo}</b>
                            </Typography>
                            <Typography fontSize={14}>
                                Date of Issue: {data.issueDate}
                            </Typography>
                            <Typography fontSize={14}>
                                Place: {toCamelCase(data.place)}
                            </Typography>
                        </Box>

                        <Box textAlign="center">
                            <Typography fontWeight="bold" fontSize={15}>
                                Authorized Signatory
                            </Typography>
                            <Divider sx={{ my: 1, width: 220 }} />
                            <Typography fontSize={14}>Principal / HR Manager</Typography>
                        </Box>
                    </Box>

                    {/* QR */}
                    <Box mt={-5} display="flex" justifyContent="center">
                        <QRCode
                            value={data.verifyUrl}
                            size={90}
                            fgColor="#573c01"
                            bgColor="#FFFFFF"
                        />
                    </Box>

                    <Typography
                        variant="caption"
                        display="block"
                        textAlign="center"
                        mt={3}
                    >
                        This is a system-generated certificate. Verification available via QR.
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default ExperienceCertificate;
